import React from "react";

function ManagedSugarTable({ users, onOpenModal }) {
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped align-middle text-center">
        <thead className="table-light">
          <tr>
            <th>帳號</th>
            <th>姓名</th>
            <th>最新血糖值</th>
            <th>最新類別</th>
            <th>平均血糖值(空腹)</th>
            <th>平均血糖值(飯後)</th>
            <th>異常</th>
            <th>最新記錄時間</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.userId}>
              <td>{u.account}</td>
              <td>{u.name}</td>
              <td>{u.latestGlucose ?? "-"}</td>
              <td>{u.latestType ?? "-"}</td>
              <td>{u.avgGlucoseT0?.toFixed(1) ?? "-"}</td>
              <td>{u.avgGlucoseT1?.toFixed(1) ?? "-"}</td>
              <td>{u.hasBSAbnormal ? "⚠️" : "✅"}</td>
              <td>{u.updatedAtBS?.slice(0, 16) ?? "-"}</td>
              <td>
                <div className="d-grid gap-1">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => onOpenModal("bloodSugar", u)}
                  >
                    新增紀錄
                  </button>
                  <button
                    className="btn btn-sm btn-secondary"
                    onClick={() => onOpenModal("bloodSugarHistory", u)}
                  >
                    歷史記錄
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ManagedSugarTable;
